import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import AccountTreeTwoToneIcon from '@material-ui/icons/AccountTreeTwoTone';
import { useState, useEffect, useCallback } from 'react';
import { useBoolean } from '@lib/common';
import { green } from '@material-ui/core/colors';
import { SubSectionTitle } from '../../common';
import { CompanyTypeEditor, Option } from './company-type-editor-v2';
import { rbac } from '@lib/common';

export const CompanyTypePicker = ({
  categoryTuple = null,
  onDone,
  clearOnDone = false,
  Component = Button,
  resetOnCancel = false,
  isLock=true,
  ...props
}: {
  categoryTuple?: Option[];
  clearOnDone?: boolean;
  resetOnCancel?: boolean;
  onDone?: (value: Option[]) => any;
  isLock?:boolean;
} & { [k: string]: any }) => {
  const [open, openPicker, closePicker] = useBoolean(false);
  const [value, setType] = useState<Option[]>(categoryTuple);
  const [dialogAlreadyOpen, setDialogAlreadyOpen] = useState(false);

  useEffect(() => {
    if (value !== categoryTuple) setType(value);
  }, [categoryTuple]);
  
  const onFinish = useCallback(() => {
    closePicker();
    setDialogAlreadyOpen(v => !v);
    onDone && onDone(value);
    clearOnDone && setType(null);
  }, [onDone, value, closePicker, clearOnDone]);

  const onCancel = () => {
    closePicker();
    setDialogAlreadyOpen(v => !v);
    resetOnCancel && categoryTuple && setType([]);
  };

  const openPickerDialog = useCallback(() => {
    openPicker();
    setDialogAlreadyOpen(v => !v);
  }, []);
  return (
    <>
      <Component
        onClick={openPickerDialog}
        disabled={isLock}
        {...props}>
        Add
      </Component>
      <Dialog open={open} onClose={onCancel}>
        <DialogTitle disableTypography>
          <SubSectionTitle
            title="Select a company Type"
            subTitle="Add a company type/sub-type."
            icon={<AccountTreeTwoToneIcon fontSize="large" style={{ color: green[600] }} />}
          />
        </DialogTitle>
        <DialogContent dividers>
          <Box p={3}>
            <CompanyTypeEditor
              value={categoryTuple}
              onChange={setType}
              dialogFirstRender={dialogAlreadyOpen}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>Cancel</Button>
          <Button color="primary" onClick={onFinish}>
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
